export default "__VITE_ASSET__DhX39Bc9__";